import { getLesson } from '../queries/theme';
import { useMutation } from '@tanstack/react-query';

export function useEssayLessonInfo() {
  const { mutate, data, isPending } = useMutation({
    mutationKey: ['essay-lesson'],
    mutationFn: (slug: string) => getLesson(slug),
    retry: false
  });

  return {
    mutate,
    data,
    isPending
  }
}